import React, { useMemo } from 'react';
import Markdown from 'markdown-to-jsx';

interface MarkdownParserProps {
  markdown: string | null | undefined;
  classNames?: string;
}

// Basic sanity check: reject strings that are suspiciously large or clearly not markdown
function isValidMarkdown(value: string): boolean {
  if (value.length > 100_000) return false;
  // Reject if the string contains no printable characters at all
  if (!/\S/.test(value)) return false;
  return true;
}

const MarkdownParser: React.FC<MarkdownParserProps> = ({
  markdown,
  classNames = 'text-14-21-0.3',
}) => {
  const content = useMemo(() => {
    if (!markdown || !isValidMarkdown(markdown)) return null;
    return markdown;
  }, [markdown]);

  if (!content) return null;

  return (
    <div className={`markdown-parser ${classNames}`}>
      <Markdown>{content}</Markdown>
    </div>
  );
};

export default MarkdownParser;
